import { POST } from "../API"

export const replyMessageAPICall = (data, conversationId, messageId, onSuccess, onError) => {
    POST(`/api/v1/chat/conversations/${conversationId}/messages/${messageId}/add_reply`, data, onSuccess, onError)
}